import '../../components/Loader/loader.less'
import { ACTION_TOKEN, fetchToken, setAuth, Token_Params } from '../login/loginSlice'
import { accessTokenKey, FROM } from '../../constants'
import { getRedirectionPath, goToLoginPage } from '../../utils/urlUtil'
import { STATES } from '../../interfaces'
import historyService from '../../services/historyService'

import LoaderView from '../../components/Loader/loader'
import { getActionState } from '../../reducers/requestReducer'
import { connect } from 'react-redux'
import React, { useEffect } from 'react'

interface IProps {
  fetchingAuthStatusState?: STATES
  fetchToken: (params: Token_Params) => void
  setAuth: (isAuth: boolean) => void
}

export const getSessionStateAndCode = () => {
  const urlSearchParams = new URLSearchParams(window.location.search)
  const sessionState = urlSearchParams.get('session_state')
  const code = urlSearchParams.get('code')

  return { sessionState, code }
}

const Loading = ({ fetchingAuthStatusState, fetchToken, setAuth }: IProps): React.ReactElement => {
  const { sessionState, code } = getSessionStateAndCode()

  const redirectTo = getRedirectionPath()

  useEffect(() => {
    const session = window.localStorage.getItem(accessTokenKey)
    if (session && session !== 'undefined') {
      setAuth(true)
      historyService.push(redirectTo)
      sessionStorage.removeItem(FROM)
    } else if (sessionState && code) {
      if (fetchingAuthStatusState == STATES.failed) {
        setTimeout(() => goToLoginPage(), 500)
      } else {
        if (fetchingAuthStatusState !== STATES.pending && sessionState && code) {
          fetchToken({
            session_state: sessionState,
            code,
            redirectURI: `${window.location.origin}`
          })
        }
      }
    } else {
      goToLoginPage()
    }
  }, [fetchingAuthStatusState])

  if (fetchingAuthStatusState == STATES.pending) {
    return <LoaderView showLoader />
  } else {
    return <></>
  }
}

const mapDispatchToProps = {
  fetchToken,
  setAuth
}

const mapStateToProps = () => ({
  fetchingAuthStatusState: getActionState(ACTION_TOKEN)
})

export default connect(mapStateToProps, mapDispatchToProps)(Loading)
